import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kycstyle.css';
import moment from "moment";



const httpClient = axios.create();
class KycStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    componentDidMount() {
    }
    componentWillUnmount() {
    }



    render() {

        return (
            <div class="mid-contant">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="head1">
                                <h2 class="success">KYC Process has been done successfuly!</h2>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="kycform">
                                <div class="row mb-3">
                                    <div class="col-12 col-lg-7">
                                        <div class="table-responsive">
                                            <table class="table table-bordered table-striped">
                                                <tbody>
                                                <tr>
                                                    <td width="150">Full Name</td>
                                                    <td>Ramesh Sharma</td>
                                                </tr>
                                                <tr>
                                                    <td>Mobile Number</td>
                                                    <td>9898989898</td>
                                                </tr>
                                                <tr>
                                                    <td>Aadhaar Number</td>
                                                    <td>1234 5678 9012</td>
                                                </tr>
                                                <tr>
                                                    <td>PAN Number</td>
                                                    <td>DLSRD3467B</td>
                                                </tr>
                                                <tr>
                                                    <td>Reference no.</td>
                                                    <td>FINXICICI123456</td>
                                                </tr>
                                                <tr>
                                                    <td>Date & time</td>
                                                    <td>29-06-2021 15:28:55</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <button type="button" class="btn btn-primary" >Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone
});

export default connect(mapStateToProps, null)(KycStatus);
